<template>
<div class="conteudoInterno" id="diretor-executivo">
  <div class="boxSeta">
    <div class="setaScrollstatic" style="" 
        :class="{ 
          setaScroll: setaScrollState 
          }"
    >
      <button><span><i class="bottom"></i></span></button>
    </div> 
  </div>
  <header class="headerSec">
    <h2>Algumas palavras do nosso diretor-executivo</h2>
    <div class="navSetas">
      <button @click="goBack()" :disabled="clicked"><span><i class="left"></i></span></button>
      <button @click="goNext()" :disabled="clicked"><span><i class="right"></i></span></button>
    </div> 
  </header>
  <div class="conteudoInternoBox">
    <section class="sectionRow">
      <div class="col23ponto5 marginColBottom">
        <span class="linecol ubcBlueBack"></span> 
      </div> 
    </section>
    <section class="sectionRow top65">
      <div class="col49">
        <img title="Marcelo Castelo Branco" alt="Marcelo Castelo Branco" src="../assets/imgs/marcelo_castelo_branco.jpg" />

        <h4 class="h4Destaque">“O ano de 2024 foi marcado por <span class="ubcBlue sanukBlack">recordes históricos em distribuição</span> e em diversas métricas que avaliam nossa operação e nosso compromisso com os titulares e a gestão coletiva.”</h4>

      </div>
      <div class="col40ponto4">
        <p>O ano de 2024 foi marcado por recordes históricos em distribuição e em diversas métricas que avaliam nossa operação e nosso compromisso com os titulares e a gestão coletiva. Este relatório anual destaca alguns desses números e configurações.</p>

        <p>Nossos resultados nos impulsionam a seguir investindo cada vez mais em tecnologia e ferramentas que promovam transparência e agilidade em tudo o que realizamos e entregamos. Nossos objetivos são claros: representar cada vez melhor aqueles que nos conferem o mandato de representação, preservando e ampliando seus direitos, além de conquistar cada vez mais espaço para suas obras e produções.</p>

        <p>Em um país de dimensões continentais como o Brasil, permanecemos atentos à rica e diversificada expressão artística, bem como ao talento das novas gerações. Por isso, ampliamos constantemente nossa base de cobertura de atendimento, seja através de escritórios próprios ou de representação.</p>

        <p>Durante o ano, desenvolvemos um calendário de eventos, incluindo o Troféu Tradições, que reconhece artistas que merecem maior visibilidade; a nova Medalha UBC; o já consagrado Prêmio UBC; e a itinerante UBC Jam, voltada para novos talentos e conexões. No ano passado, lançamos o “Palavra de Autor”, um espaço itinerante no qual ouvimos criadores falarem sobre suas obras e processos criativos.</p>

        <p>Mantivemos um portfólio de ações voltadas à educação, informação e formação de nossos titulares, contando com a participação de protagonistas do setor musical e agentes de todo o mercado. Consideramos isso um dos pilares de nossa identidade: uma sociedade progressista com quase 85 anos, que valoriza sua tradição por meio da constante inovação, empreendedorismo e aliança com seus titulares, tanto nacionais quanto internacionais.</p>

        <p>Reforçamos nossa presença institucional em Brasília, onde temas de grande relevância, como o projeto de lei sobre Inteligência Artificial e uma nova lei de Direito Autoral, estão sendo discutidos. Nossos titulares têm sido participantes ativos nesses fóruns.</p>

        <p>Ao ser a sociedade brasileira mais internacional, a UBC tem um trabalho que se estende por todo o mundo, e nossos colaboradores estão sempre atentos às melhores práticas e procedimentos para agilizar nossa operação. Essa troca é vital para nossa atualização e afirmação de nosso trabalho.</p>

        <p>É uma grande honra para mim ter sido o primeiro latino-americano designado Presidente do Conselho de Administração da Cisac, em seus quase 100 anos de existência. Durante seis anos desempenhei a função, e certamente devo essa representação à credibilidade, à reputação e ao papel da UBC no Brasil e no mundo, além da nossa equipe de colaboradores, composta por cerca de 120 funcionários, dos quais mais de 60% em cargos de liderança são mulheres.</p>

        <p>O papel da gestão coletiva e sua comunidade estarão sempre sob teste neste dinâmico ecossistema, que exige nossa atenção e adaptação.</p>

        <p>Nosso compromisso é com o futuro e com as oportunidades de melhor servir e responder às expectativas de nossos titulares de direitos.</p>

        <p>É por isso que estamos aqui. E é isso que somos.</p>
        <br />
        <p class="sanukBold ubcBlue">Marcelo Castello Branco</p>
      </div>
    </section>
  </div>
</div>
</template>

<script>
import { ShareFunctions } from '../assets/js/functions.js'

export default {
  name: 'PalavrasDiretorExecutivo',
  props:['clicked'],
  data() {
    return{
      setaScrollState: false,
    }
  },
  mounted() {
      const conteudo = document.querySelector('#diretor-executivo')
      conteudo.addEventListener('scroll', ShareFunctions.headerScroll)
  },
  methods: {
    goNext: function(){
      this.$emit("go-next");
    },
    goBack: function(){
      this.$emit("go-back");
    }, 
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .col49 img{
    width: 100%;
    max-width: 586px;
  }
  .h4Destaque {
    max-width: 586px;
    margin-top:140px;
  }
  @media screen and ( max-width: 800px ){
    .h4Destaque {
      max-width: unset;
      margin-top: 40px;
      margin-bottom: 40px;
    }
  }
</style>
